import { faPlus, faBolt, faChevronDown } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useRef, useState } from 'react'
import { Button, Form, Dropdown, Modal } from 'react-bootstrap'
import { applyOffsetToDateTime, CallApi, CommonModal, Logout } from '../../../Components/common/CommonFunctions'
import { toast } from 'react-toastify';
import { ReactComponent as EditIcon } from "../../../assets/images/settings_icon/edit.svg";
import { ReactComponent as DeleteIcon } from "../../../assets/images/settings_icon/delete.svg";
import { ReactComponent as ResetIcon } from "../../../assets/images/settings_icon/reset.svg";
import { ReactComponent as SaveIcon } from "../../../assets/images/save.svg";
import { useGetOrganizationSystemListQuery } from '../../../redux/services/SPL'
import { withRFSToken } from '../../../Services/axios'
import TableGrid from "../../../Components/common/TableGrid";
import ConfModal from '../../../Components/common/ConfModal';
import { useDispatch, useSelector } from 'react-redux'
import { clearSelectedRowsData } from '../../../redux/features/table/tableSlice'

const Device = () => {

    const isMounted = useRef(false);
    const [addModal, setAddModal] = useState(false);
    const [accessModal, setAccessModal] = useState(false);
    const [modalConf, setModalConf] = useState(false);
    const [confData, setConfData] = useState({});
    const dispatch = useDispatch()
    const [position, setPosition] = useState('');
    const [formData, setFormData] = useState({});
    const [accessRow, setAccessRow] = useState(null);
    const [pendingAccess, setPendingAccess] = useState(''); 
    const [linkModal, setLinkModal] = useState(false);
    const [dvLink, setDvLink] = useState('');
    const [originalLink, setOriginalLink] = useState('');
    const [linkType, setLinkType] = useState('');
    const inputRef = useRef(null);

    const { pageDetails, filters, sortby, selectedRows, tab } = useSelector((state) => state.table);
    const { data: myData, isFetching, refetch } = useGetOrganizationSystemListQuery();

    const columns = [
        {
            label: "", field: "actions", enableSearch: false, cls: 'tw-1',
            renderCell: (row) => (
                <div className="tb_grid_actions">
                    <ResetIcon className="row_reset" style={{ cursor: "pointer" }}
                        onClick={(e) => {
                            e.stopPropagation();
                            handleResetConfirm(row);
                        }} />
                    <EditIcon className="row_view" style={{ cursor: "pointer", marginLeft: "6px" }}
                        onClick={(e) => {
                            e.stopPropagation();
                            handleAdd('E', row);
                        }} />
                    <DeleteIcon className="row_msg" style={{ cursor: "pointer", marginLeft: "6px" }}
                        onClick={(e) => {
                            e.stopPropagation();
                            handleRemoveConfirmation([row]);
                        }} />
                </div>
            ),
        },
        { label: "Device Name", field: "device_name", enableSearch: false, cls: 'tw-10' },
        { label: "Passcode", field: "system_key", enableSearch: false, cls: 'tw-10' },
        { label: "Created At", field: "created_at", enableSearch: false, cls: 'tw-10',
          renderCell: (row) => {
            const formatted = applyOffsetToDateTime(row.created_at, "L");
            return (<div>{formatted}</div>);
            }
         },
        { label: "Access", field: "module_access", enableSearch: false, cls: 'tw-5',
            renderCell: (row) => {
            const access = row.module_access === 'B' ? 'Both' : row.module_access === 'D' ? 'Driver' : row.module_access === 'V' ? 'Visitor' : '';
            return (
                <span style={{ cursor: 'pointer' }}
                    onClick={(e) => {
                        e.stopPropagation();
                        setAccessRow(row);
                        setPendingAccess(row.module_access || '');
                        setAccessModal(true);
                    }}>
                    {access}
                </span>
            );
            }
        },
        {
            label: "Status", field: "status", enableSearch: false,
            renderCell: (row) => (
                <span style={{ color: row.status == 1 ? 'green' : 'red' }}>
                    {row.status == 1 ? 'Active' : 'Inactive'}
                </span>
            )
        },
    ];

    const handleAdd = (pos, dta) => {
        if (pos === 'E') {
            setFormData(dta);
        } else {
            setFormData({});
        }
        setPosition(pos);
        setAddModal(true);
    };

    const openLinkModal = () => {
        setLinkType('');
        setDvLink('');
        setOriginalLink('');
        setLinkModal(true);
    };
    const generateLink = async () => {
        if (!linkType) {
            toast.error('Please select an access type');
            return;
        }
        const typeMap = { D: 'Driver', V: 'Visitor', B: 'Both' };
        try {
            const res = await withRFSToken.post('vehicle-management/generate-link', { type: typeMap[linkType] });
            const innerData = res?.data?.response_data;
            if (res.data.response_code === 200) {
                setDvLink(innerData?.link || '');
                setOriginalLink(innerData?.link || '');
            } else {
                toast.error(res.data.response_msg);
            }
        } catch (error) {
            console.error('Error generating link:', error);
            toast.error('Failed to generate link');
        }
    };

    const handleCopy = () => {
        if (inputRef.current) {
            inputRef.current.select();
            inputRef.current.setSelectionRange(0, 99999);
            navigator.clipboard.writeText(inputRef.current.value);
            toast.success('Link copied!');
        }
    };

    const activateLink = () => {
        const url = inputRef.current?.value;
        const logoutUrl = localStorage.getItem('LogOut');
        if (url) {
            window.open(url, '_blank', 'noopener,noreferrer,width=1000,height=800');
        }
        Logout()
        // localStorage.clear();
        // window.location.replace(logoutUrl);
    };

    const modalClose = () => setAddModal(false);

    const HandleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value
        }));
    };

    const handleSave = () => {
        if (!formData?.device_name?.trim()) return toast.error("Device Name is required");
        if (!formData?.module_access) return toast.error("Access Type is required");

        CallApi({
            endPoint: 'vehicle-management/save-device-key',
            payload: formData,
            onSuccess: (res) => {
                if (res.data.response_code === 200) {
                    toast.success(res.data.response_msg);
                    refetch();
                    setFormData({});
                    setAddModal(false);
                } else {
                    toast.error(res.data.response_msg);
                }
            },
            onError: (msg) => toast.error(msg)
        });
    };

    const handleActiveInvoice = (id) => {
        if (selectedRows.length !== 1) {
            toast.error("Select exactly 1 device to change status");
            return;
        }
        CallApi({
            endPoint: `vehicle-management/update-organization-system/${id}`,
            method: "GET",
            onSuccess: () => {
                refetch();
                dispatch(clearSelectedRowsData(true));
                toast.success("Status Updated")
            },
            onError: (msg) => toast.error(msg)
        });
    };

    const handleRemoveConfirmation = (rows = selectedRows) => {
        if (rows.length === 0) { toast.error("Select Devices to Remove"); return; }
        setConfData({
            header: `Remove ${rows.length === 1 ? 'Device' : 'Devices'}`,
            subHeader: `Are you sure you want to remove the ${rows.length === 1 ? 'device' : 'devices'}: ${rows.map(r => r.device_name).join(', ')}?`,
            primaryBtn: "Yes",
            secondaryBtn: "No",
            modalConf: () => {
                CallApi({
                    endPoint: 'vehicle-management/delete-org-system',
                    payload: { ids: rows.map(r => r.id) },
                    onSuccess: (data) => {
                        if (data.data.response_code === 200) {
                            toast.success(data.data.response_msg);
                            dispatch(clearSelectedRowsData(true));
                            refetch();
                            setModalConf(false);
                        } else {
                            toast.error(data.data.response_msg);
                        }
                    },
                    onError: (msg) => toast.error(msg)
                });
            }
        });
        setModalConf(true);
    };

    const handleResetConfirm = (row) => {
        setConfData({
            header: "Reset Passcode",
            subHeader: `Are you sure you want to reset the passcode for device: ${row.device_name}?`,
            primaryBtn: "Yes",
            secondaryBtn: "No",
            modalConf: () => {
                CallApi({
                    endPoint: `vehicle-management/re-generate-system-key/${row.id}`,
                    method: 'patch',
                    onSuccess: (res) => {
                        if (res.data.response_code === 200) {
                            toast.success(res.data.response_msg);
                            refetch();
                            setModalConf(false);
                        } else {
                            toast.error(res.data.response_msg);
                        }
                    },
                    onError: (msg) => toast.error(msg)
                });
            }
        });
        setModalConf(true);
    };

    const handleAccessSave = () => {
        if (!accessRow || !pendingAccess) { toast.error("Please select an access type."); return; }
        CallApi({
            endPoint: 'vehicle-management/update-module-access',
            payload: { id: accessRow.id, module_access: pendingAccess },
            onSuccess: (data) => {
                if (data.data.response_code === 200) {
                    toast.success("Access updated successfully");
                    refetch();
                    setAccessModal(false);
                    setAccessRow(null);
                    setPendingAccess('');
                } else {
                    toast.error(data.data.response_msg || "Failed to update access");
                }
            },
            onError: (msg) => toast.error(msg)
        });
    };

    return (
        <>
            {modalConf &&
                <ConfModal
                    header={confData.header}
                    subHeader={confData.subHeader}
                    modalConf={confData.modalConf}
                    closeModal={() => setModalConf(false)}
                    primaryBtn={confData.primaryBtn}
                    secondaryBtn={confData.secondaryBtn}
                />
            }

            <div className='d-flex justify-content-between align-items-center'>
                <div>
                    <h4>Device Settings</h4>
                    <p>Manage and customize device configurations</p>
                </div>
                <div className='d-flex gap-2'>
                    <Button className='btn-primary' onClick={() => handleAdd('A')}>
                        <FontAwesomeIcon icon={faPlus} /> Create Device
                    </Button>
                    <Button variant='contained' className='btn-line' onClick={openLinkModal}>
                        Generate Link
                    </Button>
                    <Dropdown>
                        <Dropdown.Toggle variant="light" id="dropdown-basic" className='action'>
                            <FontAwesomeIcon icon={faBolt} /> Actions <FontAwesomeIcon icon={faChevronDown} />
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item onClick={() => handleActiveInvoice(selectedRows[0]?.id)}>Activate Device</Dropdown.Item>
                            <Dropdown.Item onClick={() => handleActiveInvoice(selectedRows[0]?.id)}>Deactivate Device</Dropdown.Item>
                            <Dropdown.Item onClick={() => handleRemoveConfirmation()}>Remove Device</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            </div>
            <hr />

            <div className='tw-50 setting_table'>
                <TableGrid
                    columns={columns}
                    rows={myData?.Rows}
                    checkboxSelection={true}
                    totalRecords={myData?.TotalRows || 0}
                    onClickRow={(row) => console.log("Clicked Row:", row)}
                    loading={isFetching}
                    rowKey="id"
                />
            </div>

            {/* Add / Edit Device Modal */}
            {addModal &&
                <CommonModal
                    show={addModal}
                    onHide={modalClose}
                    title={`${position === 'E' ? 'Update' : 'Create'} Device`}
                    subTitle={`${position === 'E' ? 'Edit' : 'Create a new'} device configuration`}
                    className='modal_bgw primary_modal'
                    footer={
                        <div className='d-flex justify-content-between'>
                            <div></div>
                            <Button variant="primary" className='defult_save' onClick={handleSave}>
                                <SaveIcon />
                                {position === 'E' ? 'Update' : 'Save'}
                            </Button>
                        </div>
                    }>
                    <Form.Group>
                        <Form.Label>Device Name <span>*</span></Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Device Name"
                            name="device_name"
                            value={formData.device_name || ''}
                            onChange={HandleChange}
                        />
                    </Form.Group>
                    <Form.Group className='mt-2'>
                        <Form.Label>Access Type <span>*</span></Form.Label>
                        <div className='d-flex'>
                            {[{ label: 'Driver', value: 'D' }, { label: 'Visitor', value: 'V' }, { label: 'Both', value: 'B' }].map(opt => (
                                <Form.Check
                                    key={opt.value}
                                    type="radio"
                                    id={`access-${opt.value}`}
                                    name="module_access"
                                    label={opt.label}
                                    value={opt.value}
                                    checked={formData.module_access === opt.value}
                                    onChange={HandleChange}
                                />
                            ))}
                        </div>
                    </Form.Group>
                </CommonModal>
            }

            {/* Access Modal */}
            {accessModal &&
                <CommonModal
                    show={accessModal}
                    onHide={() => { setAccessModal(false); setAccessRow(null); setPendingAccess(''); }}
                    title="Update Module Access"
                    subTitle="Select access type for this device."
                    className='addfrom modal_bgw primary_modal'
                    footer={
                        <div className='d-flex justify-content-between'>
                            <div></div>
                            <Button variant="primary" className='defult_save' onClick={handleAccessSave}>
                                <SaveIcon /> Save
                            </Button>
                        </div>
                    }>
                    <Form.Group>
                        {[{ label: 'Driver', value: 'D' }, { label: 'Visitor', value: 'V' }, { label: 'Both', value: 'B' }].map(opt => (
                            <Form.Check
                                key={opt.value}
                                type="radio"
                                id={`pending-${opt.value}`}
                                name="moduleAccess"
                                label={opt.label}
                                value={opt.value}
                                checked={pendingAccess === opt.value}
                                onChange={(e) => setPendingAccess(e.target.value)}
                            />
                        ))}
                    </Form.Group>
                </CommonModal>
            }
            <Modal show={linkModal} onHide={() => setLinkModal(false)} className="modal_bgw primary_modal" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Generate Link <br/> <p>Choose access type and generate link.</p></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {/* Step 1 — always visible: select access type */}
                    <Form.Group className='mb-3'>
                        <Form.Label>Access Type <span className='text-danger'>*</span></Form.Label>
                        <div className='d-flex'>
                            {[{ label: 'Driver', value: 'D' }, { label: 'Visitor', value: 'V' }].map(opt => (
                                <Form.Check
                                    key={opt.value}
                                    type="radio"
                                    id={`link-type-${opt.value}`}
                                    name="link_type"
                                    label={opt.label}
                                    value={opt.value}
                                    checked={linkType === opt.value}
                                    onChange={(e) => {
                                        setLinkType(e.target.value);
                                        setDvLink('');       // reset link if type changes
                                        setOriginalLink('');
                                    }}
                                />
                            ))}
                        </div>
                    </Form.Group>

                    {/* Step 2 — only visible after link is generated */}
                    {dvLink && (
                        <Form.Group>
                            <Form.Label>Link</Form.Label>
                            <div className='d-flex gap-2'>
                                <Form.Control
                                    type="text"
                                    ref={inputRef}
                                    name="link"
                                    value={dvLink}
                                    readOnly
                                />
                                <Button onClick={handleCopy}>Copy</Button>
                            </div>
                        </Form.Group>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <div className="d-flex w-50 mx-auto are_bottom">
                        <Button variant="secondary" onClick={() => setLinkModal(false)}>Cancel</Button>
                        {/* Shows Generate until link exists, then Activate */}
                        {!dvLink
                            ? <Button variant="primary" onClick={generateLink}>Generate</Button>
                            : <Button variant="primary" onClick={activateLink}>Activate</Button>
                        }
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default Device;